export const DEFAULT_CONTRIBUTORS_FETCH_LIMIT = 4;
export const CONFLUENCE_EDITION = {
	//copied from change-edition. Was not allowed to import it into preloadContentHeader + to prevent bundle size increase.
	FREE: 'FREE',
	PREMIUM: 'PREMIUM',
	STANDARD: 'STANDARD',
};
